export const SCHEDULED = "scheduled";
export const READY = "ready";
export const STREAMING = "streaming";
export const FINISHED = "finished";
export const CANCELLED = "cancelled";
